import type { QuestionColumns } from '@floorpoll/shared';

export interface QuestionGrid {
  cols: number;
  rows: number;
}

/**
 * How a screen's questions arrange on the big screen.
 *
 * The theme's column count is a *maximum*, not a fixed grid: a screen holding
 * one question in a three-column poll fills the width rather than hiding in a
 * narrow strip beside two empty ones.
 *
 * Where the questions do not fill the last row — two columns holding three
 * questions — the orphan keeps its column width and the remaining cell stays
 * empty. Every question on a screen is therefore the same width, which is what
 * lets two screens in a row read as the same layout.
 */
export function questionGrid(
  questionColumns: QuestionColumns | undefined,
  questionCount: number,
): QuestionGrid {
  // Absent on polls saved before the field existed.
  const setting = questionColumns ?? 1;
  const cols = Math.max(1, Math.min(setting, questionCount));
  return { cols, rows: Math.ceil(questionCount / cols) };
}
